import { render, staticRenderFns } from "./Wisdomprocess.vue?vue&type=template&id=0f3c7f7b&scoped=true&"
import script from "./Wisdomprocess.vue?vue&type=script&lang=js&"
export * from "./Wisdomprocess.vue?vue&type=script&lang=js&"
import style0 from "./Wisdomprocess.vue?vue&type=style&index=0&id=0f3c7f7b&scoped=true&lang=css&"
import style1 from "./Wisdomprocess.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3c7f7b",
  null
  
)

export default component.exports